export const isRichTextFieldEmpty = field => {
  return field === "" || field.replaceAll("<p>", "").replaceAll("</p>", "").trim() === ""
}
